import React from 'react';
import cn from 'classnames';
import Card, { CardHeader } from '../../../../../components/Card';
import styles from './InfoCard.module.scss';

const InfoCard = ({
  children,
  title,
  action,
  className,
  dark = true,
  titleClassName,
  headerClassName,
  ...props
}) => {
  return (
    <Card
      dark={dark}
      className={cn(styles.root, className)}
      {...props}
    >
      {title && (
        <CardHeader
          title={title}
          titleProps={{ className: cn(styles.title, titleClassName) }}
          className={cn(styles.header, headerClassName)}
          action={action}
        />
      )}
      {children}
    </Card>
  );
};

export default InfoCard;
